import { Button, Card, CardContent, Icon, Typography } from '@material-ui/core';
import { setNotificationWebPushDialog } from 'app/main/apps/webPush/ducks/webPush.slice';
import { subscribeToWebPushNotificationsThunk } from 'app/main/apps/webPush/ducks/webPush.thunk';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';

const ActivateNotification: React.FC = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation();

  return (
    <div className="m-0 px-0 py-24 sm:px-24 flex flex-col items-center">
      <Card elevation={0} className="border-1 border-solid border-gray-300 rounded-lg">
        <CardContent className="flex flex-col">
          <Typography variant="h6" color="textPrimary">
            {t('notification.dialog.activateTitle', { ns: 'notification' })}
          </Typography>
          <Typography variant="body1" className="mt-8 mb-32 text-gray-700">
            {t('notification.dialog.activateDescription', { ns: 'notification' })}
          </Typography>
          <div className="flex justify-between items-center gap-16">
            <Button
              onClick={() => dispatch(setNotificationWebPushDialog({ isOpen: false }))}
              className="normal-case"
              variant="outlined"
              color="primary"
            >
              <span className="hidden md:block">
                {t('notification.dialog.later', { ns: 'notification' }).toUpperCase()}
              </span>
            </Button>
            <Button
              onClick={() => {
                dispatch(subscribeToWebPushNotificationsThunk());
              }}
              className="normal-case"
              variant="contained"
              color="primary"
              endIcon={<Icon>check</Icon>}
            >
              <span className="hidden md:block">
                {t('notification.dialog.activate', { ns: 'notification' }).toUpperCase()}
              </span>
            </Button>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default ActivateNotification;
